module.exports = __webpack_public_path__ + "img/img1.fd03d380.jpg";